export default __webpack_public_path__ + "static/media/dots-gif.ba311e16.gif";